import {
  initializeFirebase,
  getFirebaseAnalytics,
  logEvent,
  getString
} from './javascript-fire-base.js';

const sections = {
  "1.0": [
    "homepage-hero-a",
  ],
  "2.0": [
    "homepage-hero-b",
  ],
  "3.0": [
    "homepage-hero-c",
  ],
  "all": [
    "horizontal-green-bar",
    "reviews",
    "how-it-works",
    "why-nomad",
    "pricing",
    "featured-in",
    "faq",
    "real-customer-stories",
    "contact"
  ]
}

async function initializeHomepageLayout() {
  try {
    const { firebaseRemoteConfig } = await initializeFirebase();

    const activeHomepageVersion = getString(firebaseRemoteConfig, "homepage_version_3");
    // alert(`Active homepage version: ${activeHomepageVersion}`);
    //
    // const activeHomepageVersion = "3.0"; // Hardcoded for testing purposes

    Object.keys(sections).forEach(version => {
      if (version !== activeHomepageVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[activeHomepageVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return activeHomepageVersion;
  } catch (error) {
    console.error("Error fetching remote config, using defaults:", error);

    const latestVersion = Object.keys(sections).filter(version => version !== "all").sort().pop();

    Object.keys(sections).forEach(version => {
      if (version !== latestVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[latestVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return latestVersion;
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  const primaryCTAs = document.querySelectorAll('.primary-cta');

  const activeHomepageVersion = await initializeHomepageLayout();

  primaryCTAs.forEach(cta => {
    cta.addEventListener('click', () => {
      logEvent(getFirebaseAnalytics(), 'primary_cta_click', {
        source: 'homepage',
        page_version: activeHomepageVersion
      });
    });
  });
})
